/*
 * In-stock first — c&c gamebridge (gamebridge.ca) — added 2026-09-11
 *
 * Shows EVERY in-stock product in a collection before ANY sold-out product,
 * across the whole collection, not just the current page.
 *
 *   Pass 1: ?filter.v.availability=1  -> products with at least one in-stock variant
 *   Pass 2: ?filter.v.availability=0  -> the rest (anything already shown is skipped,
 *                                        because a single with NM in stock and LP sold
 *                                        out is returned by both passes)
 *
 * Numbered pagination is replaced by a "Load more products" button. If the shopper
 * hasn't picked a sort, both passes are ordered by Best selling (theme setting, on by
 * default), so the page reads: best-selling in-stock products, then sold-out products.
 * If the shopper does pick a sort (Price, Newest...), that sort is used instead and
 * in-stock items still come first. Other filters are kept.
 *
 * Runs only when sections/collection-template.liquid marks the grid with
 * data-instock-first="true" (Availability filter exists, shopper hasn't picked an
 * availability value, collection has more than one page). If anything fails, the
 * normal server-rendered page and pagination are left in place.
 */
(function () {
  'use strict';
 
  var WRAP_ID = 'CollectionProductGrid';
  var GRID_ID = 'main-collection-product-grid';
  var MAX_FETCHES_PER_CLICK = 12; // safety cap so one click can't fire an unbounded number of requests
 
  function log() {
    if (window.console) console.warn.apply(console, ['[instock-first]'].concat([].slice.call(arguments)));
  }
 
  // Cards contain inline <script> (sold-out / preorder overlay). Scripts parsed by
  // DOMParser never execute when inserted, so recreate them.
  function runScripts(root) {
    root.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      if (old.src) { s.src = old.src; } else { s.textContent = old.textContent; }
      old.parentNode.replaceChild(s, old);
    });
  }
 
  function fetchPage(state, pass, page) {
    var params = new URLSearchParams(state.baseParams);
    params.set('filter.v.availability', pass === 1 ? '1' : '0');
    params.set('page', String(page));
    params.set('section_id', state.sectionId);
 
    return fetch(window.location.pathname + '?' + params.toString(), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.getElementById(GRID_ID);
        if (!grid) return { items: [], hasNext: false };
        return {
          items: [].slice.call(grid.querySelectorAll('li[data-product-id]')),
          hasNext: grid.getAttribute('data-has-next') === 'true'
        };
      });
  }
 
  function setLoading(state, on) {
    if (state.wrap) state.wrap.classList.toggle('loading', on);
    if (state.button) state.button.disabled = on;
  }
 
  function afterRender(state) {
    // Hide the numbered pagination (the section's outer .pagination-block).
    var pagination = state.wrap.querySelector('.pagination-block');
    if (pagination) pagination.style.display = 'none';
 
    state.more.style.display = '';
    state.status.textContent = 'Showing ' + Math.min(state.shown, state.total || state.shown) +
      (state.total ? ' of ' + state.total : '') + ' products';
    state.button.style.display = state.finished ? 'none' : '';
 
    // Same theme hooks collection-filters-form.js calls after it re-renders the grid.
    if (typeof window.setGridLayout === 'function') window.setGridLayout();
    if (typeof window.setupWishlistButtons === 'function') window.setupWishlistButtons();
  }
 
  function loadMore(state, isFirst) {
    if (state.busy || state.finished) return;
    state.busy = true;
    setLoading(state, true);
 
    var batch = [];
    var fetches = 0;
 
    function step() {
      if (batch.length >= state.pageSize || state.finished || fetches >= MAX_FETCHES_PER_CLICK) {
        return Promise.resolve();
      }
      if (!state.hasNext) {
        if (state.pass === 1) {
          state.pass = 2; state.page = 0; state.hasNext = true;   // in-stock exhausted -> sold-out pass
        } else {
          state.finished = true;
          return Promise.resolve();
        }
      }
      state.page += 1;
      fetches += 1;
      return fetchPage(state, state.pass, state.page).then(function (res) {
        state.hasNext = res.hasNext;
        res.items.forEach(function (li) {
          var id = li.getAttribute('data-product-id');
          if (!id || state.seen[id]) return;
          state.seen[id] = true;
          batch.push(li);
        });
        return step();
      });
    }
 
    step()
      .then(function () {
        if (isFirst && batch.length === 0) throw new Error('first batch empty');
        if (state.pass === 2 && !state.hasNext) state.finished = true;
 
        if (isFirst) {
          state.grid.innerHTML = '';
          if (state.appliedSort) {
            ['SortBy', 'SortBy-mobile'].forEach(function (id) {
              var select = document.getElementById(id);
              if (select && select.querySelector('option[value="' + state.appliedSort + '"]')) select.value = state.appliedSort;
            });
          }
        }
        batch.forEach(function (li) {
          var node = document.importNode(li, true);
          state.grid.appendChild(node);
          runScripts(node);
        });
        state.shown += batch.length;
        afterRender(state);
      })
      .catch(function (err) {
        if (isFirst) {
          log('left normal pagination in place:', err && err.message);
        } else {
          log('load more failed:', err && err.message);
          state.page -= 1; // retry the same page on the next click
          state.status.textContent = 'Could not load more products. Please try again.';
        }
      })
      .then(function () {
        state.busy = false;
        setLoading(state, false);
      });
  }
 
  function init() {
    var grid = document.getElementById(GRID_ID);
    if (!grid || grid.tagName !== 'UL') return;
    if (grid.getAttribute('data-instock-first') !== 'true') return;
    if (grid.getAttribute('data-instock-first-ready')) return;
 
    var params = new URLSearchParams(window.location.search);
    // Deep link to ?page=3 (Google, bookmarks): leave native pagination alone.
    if (parseInt(params.get('page') || '1', 10) > 1) return;
    params.delete('page');
    params.delete('section_id');
    params.delete('filter.v.availability');
 
    // Best selling by default: if the shopper hasn't picked a sort, both passes use
    // the default the section asks for (normally best-selling), and the Sort by
    // dropdowns are updated to match.
    var defaultSort = grid.getAttribute('data-default-sort');
    var appliedSort = '';
    if (defaultSort && !params.get('sort_by')) {
      params.set('sort_by', defaultSort);
      appliedSort = defaultSort; // dropdowns are updated only once the new order is on screen
    }
 
    var wrap = grid.closest('.collection');
    var more = wrap && wrap.querySelector('.instock-first-more');
    if (!wrap || !more || !grid.getAttribute('data-id')) return;
 
    grid.setAttribute('data-instock-first-ready', '1');
 
    var state = {
      grid: grid,
      wrap: wrap,
      more: more,
      status: more.querySelector('.instock-first-status'),
      button: more.querySelector('.instock-first-btn'),
      sectionId: grid.getAttribute('data-id'),
      baseParams: params.toString(),
      appliedSort: appliedSort,
      pageSize: parseInt(grid.getAttribute('data-page-size'), 10) || 16,
      total: parseInt(grid.getAttribute('data-total'), 10) || 0,
      pass: 1,
      page: 0,
      hasNext: true,
      seen: {},
      shown: 0,
      busy: false,
      finished: false
    };
 
    state.button.addEventListener('click', function () { loadMore(state, false); });
    loadMore(state, true);
  }
 
  function watchFilterReRenders() {
    // collection-filters-form.js replaces #CollectionProductGrid's innerHTML when the
    // shopper changes sort/filters or uses Back/Forward. Re-apply in-stock-first then.
    var wrap = document.getElementById(WRAP_ID);
    if (!wrap || !window.MutationObserver) return;
    new MutationObserver(function () { init(); }).observe(wrap, { childList: true });
  }
 
  function start() {
    init();
    watchFilterReRenders();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
 